// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"ProfileListCard_productDetailHeader__ouPO5","icons":"ProfileListCard_icons__w-ga+","logOutIcon":"ProfileListCard_logOutIcon__x5Ye-"};